/******************************************************************************
 *
 * ResponseControl
 *
 * Renders the appropriate response control based on
 * the runtime checklist item's response type.
 *
 ******************************************************************************/

import React from "react";

export default function ResponseControl({

    item,

    value,

    onChange

}) {

    switch (item.response_type) {

        /**************************************************************
         * YES / NO
         **************************************************************/
        case "YES_NO":

        /**************************************************************
         * PASS / FAIL
         **************************************************************/
        case "PASS_FAIL":

            return (

                <div className="d-flex gap-4">

                    <div className="form-check">

                        <input
                            type="radio"
                            className="form-check-input"
                            name={`response-${item.id}`}
                            checked={value === "YES"}
                            onChange={() => onChange("YES")}
                        />

                        <label className="form-check-label">

                            {
                                item.response_type === "PASS_FAIL"
                                    ? "Pass"
                                    : "Yes"
                            }

                        </label>

                    </div>

                    <div className="form-check">

                        <input
                            type="radio"
                            className="form-check-input"
                            name={`response-${item.id}`}
                            checked={value === "NO"}
                            onChange={() => onChange("NO")}
                        />

                        <label className="form-check-label">

                            {
                                item.response_type === "PASS_FAIL"
                                    ? "Fail"
                                    : "No"
                            }

                        </label>

                    </div>

                    <div className="form-check">

                        <input
                            type="radio"
                            className="form-check-input"
                            name={`response-${item.id}`}
                            checked={value === "NA"}
                            onChange={() => onChange("NA")}
                        />

                        <label className="form-check-label">

                            N/A

                        </label>

                    </div>

                </div>

            );

        /**************************************************************
         * TEXT
         **************************************************************/
        case "TEXT":

            return (

                <input
                    type="text"
                    className="form-control"
                    value={value || ""}
                    onChange={(e) =>
                        onChange(e.target.value)
                    }
                />

            );

        /**************************************************************
         * NUMBER
         **************************************************************/
        case "NUMBER":

            return (

                <input
                    type="number"
                    className="form-control"
                    value={value || ""}
                    onChange={(e) =>
                        onChange(e.target.value)
                    }
                />

            );

        /**************************************************************
         * DATE
         **************************************************************/
        case "DATE":

            return (

                <input
                    type="date"
                    className="form-control"
                    value={value || ""}
                    onChange={(e) =>
                        onChange(e.target.value)
                    }
                />

            );

        /**************************************************************
         * TIME
         **************************************************************/
        case "TIME":

            return (

                <input
                    type="time"
                    className="form-control"
                    value={value || ""}
                    onChange={(e) =>
                        onChange(e.target.value)
                    }
                />

            );

        /**************************************************************
         * DROPDOWN
         *
         * Phase 2
         * Options API will be connected next.
         **************************************************************/
        case "DROPDOWN":

            return (

                <select
                    className="form-select"
                    value={value || ""}
                    onChange={(e) =>
                        onChange(e.target.value)
                    }
                >

                    <option value="">

                        Select

                    </option>

                </select>

            );

        /**************************************************************
         * PHOTO
         **************************************************************/
        case "PHOTO":

            return (

                <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                />

            );

        /**************************************************************
         * SIGNATURE
         **************************************************************/
        case "SIGNATURE":

            return (

                <div className="alert alert-info mb-0">

                    Digital Signature will be implemented in Phase 3.

                </div>

            );

        /**************************************************************
         * QR SCAN
         **************************************************************/
        case "QR_SCAN":

            return (

                <div className="alert alert-info mb-0">

                    QR Scanner will be implemented in Phase 3.

                </div>

            );

        /**************************************************************
         * UNKNOWN
         **************************************************************/
        default:

            return (

                <div className="alert alert-warning mb-0">

                    Unsupported Response Type :
                    {" "}
                    <strong>

                        {item.response_type}

                    </strong>

                </div>

            );

    }

}